﻿<template>
    <div class="bd-hero">
        <nav v-if="!in_dialog" class="mb-breadcrumb" aria-label="Breadcrumb">
            <a @click="Go_Home()">
                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="home" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M341.8 72.6C329.5 61.2 310.5 61.2 298.3 72.6L74.3 280.6C64.7 289.6 61.5 303.5 66.3 315.7C71.1 327.9 82.8 336 96 336L112 336L112 512C112 547.3 140.7 576 176 576L464 576C499.3 576 528 547.3 528 512L528 336L544 336C557.2 336 569 327.9 573.8 315.7C578.6 303.5 575.4 289.5 565.8 280.6L341.8 72.6zM304 384L336 384C362.5 384 384 405.5 384 432L384 528L256 528L256 432C256 405.5 277.5 384 304 384z"/></svg>
                Home
            </a>
            <span class="mb-sep">/</span>
            <a @click="Go_Manage_Bookings()">Manage Bookings</a>
            <span class="mb-sep">/</span>
            <span class="mb-current">Booking Details</span>
        </nav>

        <p class="bd-eyebrow">Booking reference</p>
        <h2>#{{Get_Booking_Reference()}}</h2>

        <dl class="bd-meta">
            <div class="bd-meta-item">
                <dt>Agent reference</dt>
                <dd>{{Get_Agent_Reference() || '—'}}</dd>
            </div>
            <div class="bd-meta-item">
                <dt>Consultant</dt>
                <dd>{{Get_Consultant() || '—'}}</dd>
            </div>
            <div class="bd-meta-item">
                <dt>Booking date</dt>
                <dd>{{Get_Booking_Date() || '—'}}</dd>
            </div>
        </dl>
    </div>
</template>

<script lang="ts" src="./header.ts"></script>